import React from 'react';
import './style.css'; 
import LeftImage from '../../assets/images/LeftPhone.png'
import RightImage from '../../assets/images/RightPhone.png'
import { Button, Text} from "../../components";
import ImageIos from './IosdownloadImg.png'
import AndroidIcon from './googlePlaystore.png'
const Section = ({togglePopup,mainHeading,Paragraph,TextBtn}) => {
  return (
    <div className="section">
      <div className="left">
      <div className="flex flex-col gap-1 self-stretch" style={{width:'100%'}}>
                    <Text size="3xl" as="p" className="!font-generalsans !text-black-900">
                    {/* Your Car Cleaned, Wherever You Are! */}
                    {/* Park. Wash. Go! */}
                    {mainHeading}
                    </Text>
                    <Text size="xs" as="p" className="w-[88%] !text-black-900_bf md:w-full" style={{paddingTop:'10px',fontSize:'18px',paddingLeft:10}}>
                    {/* Fast and Convenient Car Wash Delivered to You – Anytime, Anywhere.
                    Subscribe for early access with promo code on your first 3 carwash! */}
                     {Paragraph}
                    </Text>
                  </div>
                  <div className='buttondiv' style={{paddingTop:'30px'}}>

                
                  {/* <Button onClick={togglePopup} shape="round" className="min-w-[120px] sm:px-1" style={{fontSize:'15px'}}>
                {TextBtn} 
                  </Button> */}
                   <div className="flex items-center gap-2">
                          <a 
                            href="https://apps.apple.com/us/app/washta/id6693265373" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="transition-transform hover:scale-105"
                           
                          >
                            <img 
                              src={ImageIos} 
                              alt="Download on the App Store" 
                              className="h-[65px] md:h-[80px] w-auto object-contain"
                            />
                          </a>
                          <a 
                            href="https://play.google.com/store/apps/details?id=com.washta" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="transition-transform hover:scale-105"
                            
                          >
                            <img 
                              src={AndroidIcon} 
                              alt="Get it on Google Play" 
                              className="h-[65px] md:h-[80px] w-auto object-contain"
                            />
                          </a>
                        </div>
                  </div>
      </div>
      <div className="right">
        {/* Phone image on the right */}
        <img src={LeftImage} alt="user" className='imageEdit classadd'   />
        <img src={RightImage} alt="user"  className='imageEdit'  />
      </div>
    </div>
  );
}

export default Section;
